var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('Header')],1),_c('el-container',[_c('el-aside',{staticStyle:{"width":"175px"}},[_c('LeftSideMenu')],1),_c('el-container',[_c('el-main',{staticStyle:{"padding-left":"10px"}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }